import { Box } from '@mui/material';
import type React from 'react';

interface FilterBadgeProps {
  count: number | boolean;
  isUpdating: boolean;
}

export const FilterBadge: React.FC<FilterBadgeProps> = ({ count, isUpdating }) => {
  if (!count) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: -5,
        right: -5,
        bgcolor: isUpdating ? 'secondary.main' : 'primary.main',
        color: 'white',
        borderRadius: '50%',
        width: 20,
        height: 20,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '0.75rem',
        fontWeight: 'bold',
        zIndex: 1,
      }}
    >
      {typeof count === 'number' ? count : '•'}
    </Box>
  );
};
